import { FontSizeRatio } from '../../styles/Typography';

export const SLIDER_MIN = 0;
export const SLIDER_MAX = 100;
export const SLIDER_STEP = 1;
export const SLIDER_DEFAULT_VALUE = 0;
export const SLIDER_MARK_LENGTH = 9;
export const SLIDER_THUMB_WIDTH = Math.round(25 * FontSizeRatio);
